<template>
	<div class="container">
		<indexPc v-if="!isTrue"></indexPc>
		<indexH5 v-if="isTrue"></indexH5>
	</div>
</template>

<script>
import indexPc from '@/component/cordx-poc-newsletter/index_pc.vue'  //pc组件
import indexH5 from '@/component/cordx-poc-newsletter/index_h5.vue'  //h5组件
export default {
	components:{
		indexPc,
		indexH5,
	},
	metaInfo: {
		meta: [
			{
				name: "description",
				content: "CorDx partners with organizations around the world to develop, manufacture, and supply diagnostics that empower users to monitor and improve their health."
			},{
				name: "keywords",
				content: "CorDx, CorDx.com , COVID-19 test, IVD R&D, manufacturing, supply chain, diagnostics, Infectious Disease, Blood Glucose, Fertility, Sexually Transmitted Diseases, Drugs of Abuse, Health Tests, Tumor Markers, Cardiac Markers"
			}
		]
	},
	data() {
		return {
			isTrue: null,
		}
	},
	created(){
		let that = this;
		let isTrue = null;
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|OpenHarmony|HarmonyOS|HarmonyOSNext|OpenHarmony/i.test(navigator.userAgent) || isiPad) {
			if(window.innerWidth > 2000) {
				that.isTrue = false;
			}else {
				that.isTrue = true;
			}
		}else {
			that.isTrue = false;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
</style>
